// extracted by mini-css-extract-plugin
export default {"overlay":"ErrorOerlay_overlay__fj0Gh","overlay__content":"ErrorOerlay_overlay__content__af9gS","error__message":"ErrorOerlay_error__message__lzXjw"};